enum ColorValue {
  BackgroundOverlay = "rgba(0, 0, 0, 0.3)",
  Dimmer = "rgba(0, 0, 0, 0.36)",
  Error = "#ff7777",
  Green = "#13bc68",
  Ghost = "#c6c6c6",
  LightBlue = "#eaffff",
  LightPink = "#ffdcdc",
  LightPurple = "#ebeaff",
  LightPurpleHover = "#d8d6ff",
  Navy = "#1d1989",
  NavyHover = "#080561",
  Pink = "#ffc8c8",
  Primary = "#363636",
  Purple = "#3530bf",
  Red = "#fd4646",
  RedHover = "#dd1111",
  Secondary = "#838383",
  Tertiary = "#e1e1e1",
  White = "#ffffff",
  Yellow = "#ffbb37",
}

export default ColorValue;
